export enum ENUM__ml_asset_config_key {
  COMMON__ENVIRONMENT = 'common__environment',

  CONTROL_NET_TYPE = 'control_net__type',

  LORA__IS_LCM = 'lora__is_lcm',
  LORA_DISTRIBUTION_UNET = 'lora__distribution_unet',
  LORA_DISTRIBUTION_TEXT_ENCODER = 'lora__distribution_text_encoder',
  LORA_DISTRIBUTION_OTHER = 'lora__distribution_other',
  LORA__TAG_FREQUENCY = 'lora__tag_frequency',

  UNET__TYPE = 'unet__type',

  EMBEDDING__SIGN_IS_POSITIVE = 'embedding__sign_is_positive',

  T2I_ADAPTER__TYPE = 't2i_adapter__type',
}
